import React, { useState } from 'react';
import { Text } from '../Text';
import { HelpText } from '../HelpText';
import { parseMinMax, percentTrack, parseValuesBetween } from '../../helpers';
import { rangeSliderDefaultProps } from './props';
import * as S from '../Slider/styles';
/**
 * Componente Range Slider do Design System OLX
 */
export const RangeSlider = props => {
  const [active, setActive] = useState(false);
  const [min, max] = parseMinMax(props.min, props.max);
  const value = parseValuesBetween(props.value, min, max);
  const handleMouseUp = () => setActive(false);
  const handleMouseDown = () => setActive(true);
  const handleBlur = () => setActive(false);
  const handleInputStart = event => {
    var _a;
    (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, [Math.min(Number(event.target.value), value[1]), value[1]]);
  };
  const handleInputEnd = event => {
    var _a;
    (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, [value[0], Math.max(Number(event.target.value), value[0])]);
  };
  const handleKeyUp = event => {
    if ((event.key === 'ArrowLeft' || event.key === 'ArrowRight') && !active) {
      setActive(true);
    }
  };
  const trackFinal = percentTrack(value[0], min, max);
  const trackEnd = percentTrack(value[1], min, max);
  return React.createElement(S.Wrap, null, React.createElement(S.Slider, null, React.createElement(S.Track, {
    active: active,
    error: props.error,
    disabled: props.disabled,
    start: trackFinal,
    end: trackEnd
  }), React.createElement(S.Input, {
    role: "slider",
    "data-ds-component": "DS-Range-Slider",
    type: "range",
    min: min,
    max: max,
    step: props.step,
    error: props.error,
    disabled: props.disabled,
    id: props.id,
    value: value[0],
    onTouchEnd: handleMouseUp,
    onTouchStart: handleMouseDown,
    onMouseUp: handleMouseUp,
    onMouseDown: handleMouseDown,
    onKeyUp: handleKeyUp,
    onBlur: handleBlur,
    onInput: handleInputStart
  }), React.createElement(S.Input, {
    role: "slider",
    "data-ds-component": "DS-Range-Slider",
    type: "range",
    min: min,
    max: max,
    step: props.step,
    error: props.error,
    disabled: props.disabled,
    value: value[1],
    onTouchEnd: handleMouseUp,
    onTouchStart: handleMouseDown,
    onMouseUp: handleMouseUp,
    onMouseDown: handleMouseDown,
    onKeyUp: handleKeyUp,
    onBlur: handleBlur,
    onInput: handleInputEnd
  })), React.createElement(S.Overline, null, React.createElement(Text.BodySmall, {
    weight: "regular"
  }, min), React.createElement(Text.BodySmall, {
    weight: "regular"
  }, max)), props.helpText && React.createElement(S.HelpText, null, React.createElement(HelpText, {
    isError: props.error
  }, props.helpText)));
};
RangeSlider.displayName = 'RangeSlider';
RangeSlider.defaultProps = rangeSliderDefaultProps;